(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!matchMedia('(hover: hover) and (pointer: fine)').matches)return;
  var sel='.header__inline-menu>.list-menu>li>a.header__menu-item,.header__inline-menu>.list-menu>li>header-menu>details>summary.header__menu-item';
  function bind(){
    document.querySelectorAll(sel).forEach(function(el){
      if(el.dataset.glass)return;el.dataset.glass='1';
      el.addEventListener('pointermove',function(e){
        var r=el.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
        el.style.setProperty('--ry',((x-.5)*16).toFixed(2)+'deg');
        el.style.setProperty('--rx',((.5-y)*14).toFixed(2)+'deg');
        el.style.setProperty('--mx',(x*100).toFixed(1)+'%');
        el.style.setProperty('--my',(y*100).toFixed(1)+'%');
      });
      el.addEventListener('pointerleave',function(){el.style.setProperty('--rx','0deg');el.style.setProperty('--ry','0deg');});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
  document.addEventListener('shopify:section:load',bind);
})();
